import React from 'react'
import { Table } from '../../components'

export const PatientSearchRes = ({data = false, columns}) => {
    return (
        <Table columns={columns} data={data ? data : []} status='all' />
    )
}
